import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { COPY } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';

interface LibraryInsertDialogProps {
  open: boolean;
  name?: string;
  busy?: boolean;
  onCancel: () => void;
  onChoose: (follow: boolean) => void;
}

const LibraryInsertDialog: React.FC<LibraryInsertDialogProps> = ({
  open,
  name,
  busy,
  onCancel,
  onChoose,
}) => (
  <Dialog open={open} onClose={busy ? undefined : onCancel} fullWidth maxWidth="sm">
    <DialogTitle>
      {name ? `${COPY.libraryInsertTitle} “${name}”` : COPY.libraryInsertTitle}
    </DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: 1 }}>
      <Box>
        <Button
          fullWidth
          disabled={busy}
          variant="contained"
          onClick={() => onChoose(true)}
          sx={{ bgcolor: PRES.interactive, textTransform: 'none', boxShadow: 'none', fontWeight: 700, py: 1.25 }}
        >
          {COPY.libraryInsertFollow}
        </Button>
        <Typography sx={{ mt: 0.75, fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textSecondary }}>
          {COPY.libraryInsertFollowHelp}
        </Typography>
      </Box>
      <Box>
        <Button
          fullWidth
          disabled={busy}
          variant="outlined"
          onClick={() => onChoose(false)}
          sx={{ textTransform: 'none', fontWeight: 700, py: 1.25, borderColor: PRES.borderStrong, color: PRES.textPrimary }}
        >
          {COPY.libraryInsertOwn}
        </Button>
        <Typography sx={{ mt: 0.75, fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textSecondary }}>
          {COPY.libraryInsertOwnHelp}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button disabled={busy} onClick={onCancel} sx={{ textTransform: 'none' }}>{COPY.cancel}</Button>
    </DialogActions>
  </Dialog>
);

export default LibraryInsertDialog;
